import { style } from '../layer.css';

export const hintTrigger = style({
  all: 'unset',
  display: 'flex',
  width: 'fit-content',
  cursor: 'pointer',
  pointerEvents: 'auto',
});
